import { inWindow } from '@/config';
var Browser;
(function (Browser) {
    Browser["SAFARI"] = "safari";
    Browser["CHROME"] = "chrome";
    Browser["FIREFOX"] = "firefox";
    Browser["EDGE"] = "edge";
    Browser["OPERA"] = "opera";
    Browser["IE"] = "ie";
    Browser["POPO"] = "popo";
    Browser["WEIXIN"] = "micromessenger";
    Browser["MAIL_MASTER"] = "MailMaster";
    Browser["SIRIUS"] = "sirius";
})(Browser || (Browser = {}));
var OS;
(function (OS) {
    OS["ANDROID"] = "android";
    OS["IOS"] = "ios";
    OS["MAC_OS"] = "macos";
    OS["WINDOWS"] = "windows";
    OS["FIREFOX_OS"] = "firefoxos";
})(OS || (OS = {}));
const BROWSER_RULES = [
    [Browser.POPO, /Mobile.*\/.*POPO/],
    [Browser.WEIXIN, /Mobile.*\/.*MicroMessenger/],
    [Browser.MAIL_MASTER, /Mobile.*\/.*MailMaster/],
    [Browser.SIRIUS, /Mobile.*\/.*Sirius/],
    [Browser.EDGE, /Edge\/([0-9._]+)/],
    [Browser.CHROME, /(?!Chrom.*OPR)(Chrom(?:e|ium)|CriOS)\/([0-9.]+)(:?\s|$)/],
    [Browser.FIREFOX, /Firefox\/([0-9.]+)(?:\s|$)/],
    [Browser.OPERA, /Opera\/([0-9.]+)(?:\s|$)/],
    [Browser.OPERA, /OPR\/([0-9.]+)(:?\s|$)$/],
    [Browser.IE, /Trident\/7\.0.*rv:([0-9.]+)\).*Gecko$/],
    [Browser.IE, /MSIE\s([0-9.]+);.*Trident\/[4-7].0/],
    [Browser.IE, /MSIE\s(7\.0)/],
    [Browser.SAFARI, /Version\/([0-9._]+).*Safari/],
];
const OS_RULES = [
    [OS.IOS, /os ([._\d]+) like mac os/i],
    [OS.MAC_OS, /mac os x/i],
    [OS.ANDROID, /android/i],
    [OS.FIREFOX_OS, /mozilla\/[a-z._\d]+ \((?:mobile)|(?:tablet)/i],
    [OS.WINDOWS, /windows\s*(?:nt)?\s*[._\d]*/i],
];
class Platform {
    constructor() {
        if (inWindow()) {
            this.browser = this._browser;
            this.os = this._os;
        }
    }
    get _browser() {
        return this.getBrowserName();
    }
    get _os() {
        return this.getOSName();
    }
    getBrowserName() {
        for (const [name, regexp] of BROWSER_RULES) {
            if (regexp.test(window.navigator.userAgent)) {
                return name;
            }
        }
        return undefined;
    }
    getOSName() {
        for (const [name, regexp] of OS_RULES) {
            if (regexp.test(window.navigator.userAgent)) {
                return name;
            }
        }
        return undefined;
    }
    isSafari() {
        return this.browser === Browser.SAFARI;
    }
    isChrome() {
        return this.browser === Browser.CHROME;
    }
    isAndroid() {
        return this.os === OS.ANDROID;
    }
    isIOS() {
        return this.os === OS.IOS;
    }
    isMac() {
        return this.os === OS.MAC_OS;
    }
    isWindows() {
        return this.os === OS.WINDOWS;
    }
    isMobile() {
        return this.isAndroid() || this.isIOS();
    }
    isPOPO() {
        return this.browser === Browser.POPO;
    }
    isWeixin() {
        return this.browser === Browser.WEIXIN;
    }
    isMailMaster() {
        return this.browser === Browser.MAIL_MASTER;
    }
    isElectron() {
        return /electron/i.test(window.navigator.userAgent);
    }
    getMobileApp() {
        const app = [Browser.POPO, Browser.WEIXIN, Browser.SIRIUS, Browser.CHROME, Browser.SAFARI].find(browser => this.browser === browser);
        return app === Browser.WEIXIN ? 'weixin' : app !== null && app !== void 0 ? app : 'other';
    }
    isIPhoneX() {
        return navigator.userAgent.toLowerCase().indexOf('iphone') > -1 && window.screen.height >= 812 && window.devicePixelRatio >= 2;
    }
    isSirius() {
        return this.browser === Browser.SIRIUS;
    }
    isSiriusMobile() {
        if (this.isSirius()) {
            return true;
        }
        if (this.isSafari() || this.isChrome() || this.isWeixin() || this.isMailMaster()) {
            return false;
        }
        return true;
    }
}
const platform = new Platform();
export { platform, Platform };
